export function isValidInternationalPhone(countryCode, nationalNumber) {
  const normalizedCountryCode = String(countryCode || '').trim();
  const normalizedNationalNumber = String(nationalNumber || '').trim();

  if (!/^\+[1-9]\d{0,2}$/.test(normalizedCountryCode)) {
    return false;
  }
  if (!/^\d+$/.test(normalizedNationalNumber)) {
    return false;
  }

  const withoutTrunkPrefix = normalizedNationalNumber.replace(/^0/, '');
  return /^\+[1-9]\d{6,14}$/.test(`${normalizedCountryCode}${withoutTrunkPrefix}`);
}
